import type { PageProps } from '@ps-smart-cp/ppfw-client';
import { Navigate, useLocation } from 'react-router';

interface WithLocationStateProps<P extends PageProps> {
  Component: (props: P) => React.JSX.Element;
  fallBackTo: string;
}

function withLocationState<P extends PageProps>({ Component, fallBackTo }: WithLocationStateProps<P>) {
  return function WrappedComponent(props: P) {
    const location = useLocation();
    return location.state ? <Component {...props} /> : <Navigate to={fallBackTo} />;
  };
}

export type { WithLocationStateProps };
export { withLocationState };
